<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full">
      <div class="p-6">
        <h3 class="text-lg font-bold mb-4">Duplicate Checklist</h3>
        <p class="text-gray-600 mb-6">
          Are you sure you want to duplicate "{{ checklistTitle }}"? 
          A new copy will be created with "-COPY" suffix.
        </p>
        
        <div class="flex justify-end gap-4">
          <button 
            @click="$emit('cancel')"
            class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Cancel
          </button>
          <button 
            @click="$emit('confirm')"
            class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Duplicate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checklistTitle: {
      type: String,
      required: true
    }
  }
}
</script>
